/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    permissions: 'view-user',
  },
  {
    header: 'Manage Customers',
    icon: 'ArchiveIcon',
    items: [
      {
        url: '/pages/partner-customers',
        name: 'Customers',
        slug: 'customers',
        icon: 'UserIcon',
        i18n: 'customers',
        permissions: 'view-user',
      },
      {
        url: '/pages/partner-users',
        name: 'Users',
        slug: 'users',
        icon: 'UsersIcon',
        i18n: 'users',
        permissions: 'view-user',
      },
    ]
  },
  // {
  //   header: 'L2 Settings',
  //   icon: 'ArchiveIcon',
  //   items: [
  //     {
  //       url: '/pages/tenants',
  //       name: 'Tenants',
  //       slug: 'tenants-list',
  //       icon: 'HomeIcon',
  //       i18n: 'Tenants',
  //       permissions: 'view-user',
  //     },
  //     {
  //       url: '/pages/pricing-tiers',
  //       name: 'Pricing',
  //       slug: 'manage-pricing-tiers',
  //       icon: 'DollarSignIcon',
  //       i18n: 'Pricing',
  //       permissions: 'view-user',
  //     },
  //     {
  //       url: '/pages/channel-partners',
  //       name: 'Channel Partners',
  //       slug: 'manage-channel-partners',
  //       icon: 'UsersIcon',
  //       i18n: 'Channel Partners',
  //       permissions: 'view-user',
  //     },
  //   ],
  // },
  // {
  //   header: 'HELP GUIDE',
  //   icon: 'ArchiveIcon',
  //   items: [
  //     {
  //       url: '/pages/help-tags',
  //       name: 'Guide List',
  //       slug: 'manage-help-tags',
  //       icon: 'InfoIcon',
  //       i18n: 'Help Tags',
  //       permissions: 'view-user',
  //     },
  //     {
  //       url: '/pages/help-tags-categories',
  //       name: 'Guide Categories',
  //       slug: 'manage-help-tags-categories',
  //       icon: 'TagIcon',
  //       i18n: 'Help Tags',
  //       permissions: 'view-user',
  //     }
  //   ]
  // }
]
